module.exports = __webpack_public_path__ + "img/kbc.f0b804a.svg";